import { Component, Input } from "@angular/core";

@Component({
  selector: "app-nodatafound",
  standalone: false,
  templateUrl: "./nodatafound.component.html",
  styleUrl: "./nodatafound.component.css",
})
export class NodatafoundComponent {
  @Input() title!: string;
}
